export default __webpack_public_path__ + "static/media/Better_IoT_with_Serverless_GraphQL_ServerlessDays_Istanbul.c0dd4ae3.png";